<router-outlet></router-outlet> <ngx-spinner></ngx-spinner>
